import React from 'react';
import { Alert } from 'antd';
import { MessageHOC } from '../shared';
import messageIds from './messages';
import { formatOccurredAt } from './loginAccessDenied';

const AccessDeniedAlert = ({ getMessages, email, occurredAt }) => {
  const messages = getMessages(messageIds);
  return (
    <Alert
      className="login-access-denied"
      type="error"
      showIcon
      message={messages.access_denied_title}
      description={
        <div className="access-denied-message">
          <p>{messages.access_denied_error}</p>
          <p>
            {messages.access_denied_email} <strong>{email || '-'}</strong>
            <br />
            {messages.access_denied_date_time}{' '}
            <strong>{occurredAt ? formatOccurredAt(occurredAt) : '-'}</strong>
          </p>
        </div>
      }
    />
  );
};

export default MessageHOC()(AccessDeniedAlert);
